<div class="batch-order-list">
  <mat-paginator
    class="batch-order-list__paginator"
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
    (page)="onPageChange($event)"
    aria-label="Select page of orders"
  >
  </mat-paginator>

  <div class="mbp-table-wrap">
    <table mat-table matSort [dataSource]="ordersDataSource" class="mbp-data-table batch-order-list__table">
      <ng-container matColumnDef="orderNumber">
        <th mat-header-cell *matHeaderCellDef class="id-col">#</th>
        <td mat-cell *matCellDef="let order" class="id-col">{{ order.id }}</td>
      </ng-container>

      <ng-container matColumnDef="amount_required">
        <th mat-header-cell *matHeaderCellDef>Amount required</th>
        <td mat-cell *matCellDef="let order">{{ getAmountRequired(order) }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row (click)="openOrder(row.id)" *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
